import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Download, ShieldCheck, Star, Users } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-28 pb-20 px-4 md:px-8" data-id="element-65">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none opacity-40" data-id="element-66">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-sage/20 to-transparent" data-id="element-67" />
        <div className="absolute top-20 -right-24 w-96 h-96 bg-amber/10 rounded-full blur-3xl" data-id="element-68" />
        <div className="absolute bottom-10 left-10 w-72 h-72 bg-forest/5 rounded-full blur-3xl" data-id="element-69" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-70">
        {/* Left Column: Text Content */}
        <div className="flex-1 text-center lg:text-left" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="inline-flex items-center bg-sage/10 border border-sage/30 rounded-full px-4 py-1.5 mb-8" data-id="element-72">
            <Users className="w-4 h-4 text-forest mr-2" data-id="element-73" />
            <span className="text-sm font-medium text-forest" data-id="element-74">
              Más de 500 personas ya la descargaron
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-forest mb-6 leading-tight" data-id="element-75">
            Aprende a Crear Pomadas Naturales desde Casa
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-lg md:text-xl text-brown/80 font-light mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-76">
            Una guía práctica con recetas probadas para cuidar tu piel de forma
            natural, sin químicos y con ingredientes simples.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-col items-center lg:items-start" data-id="element-77">
            <button onClick={scrollToPricing} className="bg-amber text-white px-10 py-5 rounded-full font-bold text-lg md:text-xl hover:scale-105 transition-transform shadow-xl hover:shadow-2xl flex items-center group" data-id="element-78">
              Quiero Mi Guía Ahora
              <Download className="ml-3 w-6 h-6 group-hover:translate-y-1 transition-transform" data-id="element-79" />
            </button>

            <div className="mt-6 flex flex-wrap justify-center lg:justify-start items-center gap-4 text-sm text-brown/70 font-medium" data-id="element-80">
              <span className="flex items-center" data-id="element-81">
                <ShieldCheck className="w-4 h-4 mr-1 text-sage" data-id="element-82" /> Descarga
                inmediata
              </span>
              <span className="hidden md:inline text-sage/50" data-id="element-83">•</span>
              <span className="flex items-center" data-id="element-84">
                <Star className="w-4 h-4 mr-1 text-amber" data-id="element-85" /> Formato digital
              </span>
              <span className="hidden md:inline text-sage/50" data-id="element-86">•</span>
              <span className="flex items-center" data-id="element-87">
                <Leaf className="w-4 h-4 mr-1 text-forest" data-id="element-88" /> 6 recetas
                incluidas
              </span>
            </div>

            <p className="mt-4 text-amber font-semibold text-sm animate-pulse" data-id="element-89">
              ⚡ Precio especial por tiempo limitado
            </p>
          </motion.div>
        </div>

        {/* Right Column: CSS Book Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotateY: -10
      }} animate={{
        opacity: 1,
        scale: 1,
        rotateY: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="flex-1 flex justify-center lg:justify-end perspective-[1000px] w-full max-w-md mx-auto lg:max-w-none" data-id="element-90">
          {/* The Book */}
          <div className="relative w-64 h-80 md:w-80 md:h-[400px] transform-gpu rotate-y-[-15deg] rotate-x-[5deg] shadow-2xl rounded-r-2xl rounded-l-sm transition-transform duration-500 hover:rotate-y-[-5deg] hover:rotate-x-[2deg]" data-id="element-91">
            {/* Book Spine (Left Edge) */}
            <div className="absolute left-0 top-0 bottom-0 w-4 bg-forest/90 rounded-l-sm transform -translate-x-full origin-right rotate-y-90 shadow-[inset_-2px_0_5px_rgba(0,0,0,0.2)]" data-id="element-92"></div>

            {/* Book Pages (Right Edge) */}
            <div className="absolute right-0 top-1 bottom-1 w-6 bg-white transform translate-x-full origin-left -rotate-y-90 rounded-r-sm shadow-[inset_2px_0_5px_rgba(0,0,0,0.1)] flex flex-col justify-evenly py-2" data-id="element-93">
              <div className="h-px w-full bg-gray-200" data-id="element-94"></div>
              <div className="h-px w-full bg-gray-200" data-id="element-95"></div>
              <div className="h-px w-full bg-gray-200" data-id="element-96"></div>
              <div className="h-px w-full bg-gray-200" data-id="element-97"></div>
              <div className="h-px w-full bg-gray-200" data-id="element-98"></div>
            </div>

            {/* Book Cover */}
            <div className="absolute inset-0 bg-gradient-to-br from-forest to-[#1a330d] rounded-r-2xl rounded-l-sm border-l border-white/20 shadow-[inset_4px_0_10px_rgba(0,0,0,0.4)] overflow-hidden flex flex-col items-center justify-center p-6 text-center" data-id="element-99">
              {/* Cover Decoration */}
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white to-transparent" data-id="element-100"></div>
              <div className="absolute top-4 left-4 right-4 bottom-4 border border-sage/30 rounded-xl" data-id="element-101"></div>

              <div className="relative z-10" data-id="element-102">
                <div className="w-16 h-16 mx-auto bg-sage/20 rounded-full flex items-center justify-center mb-6 border border-sage/40" data-id="element-103">
                  <Leaf className="w-8 h-8 text-sage" data-id="element-104" />
                </div>
                <h2 className="text-3xl md:text-4xl font-playfair font-bold text-parchment mb-4 leading-tight" data-id="element-105">
                  Pomadas
                  <br data-id="element-106" />
                  Naturales
                </h2>
                <div className="w-12 h-px bg-amber mx-auto mb-4" data-id="element-107"></div>
                <p className="text-sm text-parchment/80 font-light uppercase tracking-widest" data-id="element-108">
                  Guía Práctica
                </p>
              </div>
            </div>

            {/* Book Shadow */}
            <div className="absolute -bottom-6 -right-6 -left-2 h-12 bg-black/20 blur-xl rounded-full transform -translate-z-10" data-id="element-109"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}